import { readWorkspaceLocalJson, WS_KEY } from "./workspaceStorage";

export function loadLastSeenClientAtMap() {
  try {
    const parsed = readWorkspaceLocalJson(WS_KEY.CHAT_LAST_SEEN, {});
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

/** MySQL `YYYY-MM-DD HH:mm:ss` quebra no Safari se o espaço não virar `T`. */
export function parseUnreadDateMs(value) {
  if (value == null || value === "") return null;
  const normalized = String(value).trim().replace(" ", "T");
  const dt = new Date(normalized);
  return Number.isNaN(dt.getTime()) ? null : dt.getTime();
}

export function hasUnreadClientMessage(conversation, lastSeenMap = {}) {
  const lastClientAt =
    conversation?.lastClientMessageAt ?? conversation?.last_client_message_at;
  const lastMs = parseUnreadDateMs(lastClientAt);
  if (lastMs == null) return false;
  const id = conversation?.id;
  const seenAt =
    lastSeenMap?.[id] ?? lastSeenMap?.[String(id)] ?? null;
  const seenMs = parseUnreadDateMs(seenAt);
  if (seenMs == null) return true;
  return lastMs > seenMs;
}

export function countUnreadClientConversations(conversations = [], lastSeenMap = {}) {
  const list = Array.isArray(conversations) ? conversations : [];
  return list.reduce(
    (sum, conversation) => sum + (hasUnreadClientMessage(conversation, lastSeenMap) ? 1 : 0),
    0
  );
}
